export const preview = {
  previewImage: (image_url) => {
    const exten = image_url.split(".").pop();
    const checkexten = ["pdf", "docx", "csv"];
    if (!checkexten.includes(exten)) {
      const image_window = window.open("", "_blank");
      image_window.document.write(`
                    <html>
                      <head>
                      </head>
                      <body>
                        <img src=${image_url} alt="Example" height="100%" width="100%">
                      </body>
                    </html>
              `);
    } else {
      window.open(image_url, "_blank");
    }
  },
};
